// extracted by mini-css-extract-plugin
export var boldText = "_2y-4";
export var checkboxContainer = "_2y-6";
export var closeIcon = "_2y-i";
export var container = "_2y-0";
export var drawer = "_2y-8";
export var drawerContent = "_2y-9";
export var extraSmallText = "_2y-5";
export var fulfillmentGroupTable = "_2y-e";
export var largeText = "_2y-3";
export var loadingSpinnerContainer = "_2y-j";
export var mediumText = "_2y-2";
export var narrow = "_2y-f";
export var notificationLink = "_2y-l";
export var packageCheckIconContainer = "_2y-7";
export var slideoutHeaderActions = "_2y-g";
export var slideoutHeaderActionsShifted = "_2y-h";
export var slideoutHeaderContainer = "_2y-a";
export var slideoutModal = "_2y-c";
export var stickyHeaderWrapper = "_2y-b";
export var table = "_2y-k";
export var tableContainer = "_2y-d";
export var tertiaryText = "_2y-1";